import { render, staticRenderFns } from "./BrandProfilesIcon.vue?vue&type=template&id=4cf17d60"
import script from "./BrandProfilesIcon.vue?vue&type=script&lang=js"
export * from "./BrandProfilesIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports